/**
 * Raised when GET shipperguide/carrier/me rejects the credential
 * (missing, tampered, Alice, or shipper tokens).
 */
export class IncorrectCredentialsError extends Error {
  constructor() {
    super('Incorrect authentication credentials.')
    this.name = 'IncorrectCredentialsError'
  }
}
